<script setup>

    import { ref, computed, watch } from 'vue'
    import { useScheduleItemStore } from "@/stores/ScheduleItemStore"
    // import {  } from 'fs';
    // import { debounce } from "debounce"

    const searchText = ref("")
    
    const store = useScheduleItemStore()

    const handleSearch = () => {
        // console.log( searchText.value )
        if ( searchText.value.length > 2 || searchText.value === '' ) {
            store.setCurrentFilter('search', searchText.value)
        }
    }

    const matchStore = computed( () => {
        return store.currentFilters.search
    })
    watch( matchStore,
        (newValue) => {
            searchText.value = newValue
        },
        { deep: true }
    )

    // const debounceHandleSearch = () => {
    //     console.log( 'debounceHandleSearch' )
    //     debounce( handleSearch(), 100 )
    // }

</script>
<template>
    <div class="sles__header__filters__search" :class="store.currentFilters.search !== '' ? 'active' : ''">
        <input
            id="search"
            name="search" 
            type="text"
            v-model="searchText"
            @input.prevent="handleSearch"
            placeholder="Search the schedule..."
        />
        <label for="search"><span class="screen-reader-text">Search</span><svg class="svgicon"><use xlink:href="#svg-search"></use></svg></label>
    </div>
</template>

